import { ThemeProvider } from "styled-components";
import { token } from "../../theme";
import {
  ProjectDetailsImage,
  ProjectDetailsImageContainer,
  ProjectDetailsWindowContainer,
} from "./ProjectDetailsWindowStyles";
import { TransformedWebProjectModel } from "../../pages/HomePage/utils/types";
import Tabs from "../Tabs/Tabs";
import { Flex, Space, Tag, Typography } from "antd";

interface ProjectDetailsWindowProps {
  project: TransformedWebProjectModel;
}

const { Title, Text, Paragraph, Link } = Typography;

const ProjectDetailsWindow = ({ project }: ProjectDetailsWindowProps) => {
  const renderImagesView = () => {
    return (
      <Flex
        vertical
        style={{
          width: "100%",
          height: 500,
          overflowY: "auto",
          overflowX: "hidden",
        }}
        align="center"
      >
        <ProjectDetailsImageContainer>
          {project.media.map((media) => {
            return <ProjectDetailsImage src={media.url} />;
          })}
        </ProjectDetailsImageContainer>
      </Flex>
    );
  };

  const renderGeneralView = () => {
    return (
      <Flex
        vertical
        style={{
          width: "100%",
          height: 500,
          overflowY: "auto",
          overflowX: "hidden",
          padding: "1rem",
          fontSize: token.fontNormal,
          gap: "1.25rem",
        }}
      >
        <h2 style={{ margin: 0, fontSize: "1.5rem" }}>{project.title}</h2>

        {project.dateCompleted && (
          <div>
            <span>Date Completed: </span>
            <span>{project.dateCompleted}</span>
          </div>
        )}

        {project.techStack && project.techStack.length > 0 && (
          <div>
            <span>Tech Stack: </span>
            <span>{project.techStack.join(", ")}</span>
          </div>
        )}

        {project.description && (
          <div>
            <div style={{ marginBottom: "0.25rem" }}>Description:</div>
            <p style={{ margin: 0, lineHeight: 1.5 }}>{project.description}</p>
          </div>
        )}

        {project.link && (
          <div>
            <span>Project Link: </span>
            <a
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "underline" }}
            >
              {project.link}
            </a>
          </div>
        )}
      </Flex>
    );
  };
  return (
    <ThemeProvider theme={token}>
      <ProjectDetailsWindowContainer>
        <div style={{ padding: "1rem" }}>
          <Tabs
            items={[
              { title: "General", content: renderGeneralView() },
              { title: "View", content: renderImagesView() },
            ]}
          />
        </div>
      </ProjectDetailsWindowContainer>
    </ThemeProvider>
  );
};

export default ProjectDetailsWindow;
